import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';

import '../SportsFilters.scss';
import Loading from '../../../Loading/Loading';
import TreeItem from './TreeItem';

class Tree extends PureComponent {

  renderQuickLinks = () => {
    return (
      <TreeItem
        item={
          {
            name: this.props.t('tree.topFilter')
          }
        }
        level={ -1 }
      >
        {
          _.map(this.props.eventsTop, (top) => (
            <TreeItem
              key={ top.topFilter }
              item={ top }
            />
          ))
        }
      </TreeItem>
    );
  }

  renderTree = () => {
    return (
      <>
        {
          this.props.treeLoading && (
            <div className="tree__loading">
              <Loading contained forceLoading />
            </div>
          )
        }

        {
          _.map(this.props.eventsTree, (sport) => (
            <TreeItem
              key={ sport.name + sport.code }
              item={ sport }
              level={ 0 }
            >
              {
                sport.categories && _.map(sport.categories, (category) => (
                  <TreeItem
                    key={ category.name + category.code }
                    item={ category }
                    sport={ sport.code }
                    level={ 1 }
                  >
                    {
                      category.tournaments && _.map(category.tournaments, (tournament, i) => (
                        <TreeItem
                          key={ tournament.name + tournament.code + i }
                          item={ tournament }
                          sport={ sport.code }
                          category={ category.code }
                          level={ 2 }
                        />
                      ))
                    }
                  </TreeItem>
                ))
              }
            </TreeItem>
          ))
        }
      </>
    );
  }

  render() {
    return (
      <ul className="tree__list">
        {
          this.props.quickLinks
            ? this.renderQuickLinks()
            : this.renderTree()
        }
      </ul>
    );
  }
}

Tree.propTypes = {
  t: PropTypes.func,
  children: PropTypes.array,
  eventsTree: PropTypes.array,
  treeLoading: PropTypes.bool,
  eventsTop: PropTypes.array,
  quickLinks: PropTypes.bool
};

Tree.defaultProps = {
  quickLinks: false
};

const mapState = state => ({
  eventsTree: state.events.eventsTree,
  treeLoading: state.events.treeLoading,
  eventsTop: state.events.eventsTop
});

export default connect(mapState, null)(withTranslation('common')(Tree));
